import type { Resource } from '../../';
export const product_details_model: Resource = {"default":"Model: {model}"};
